import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Stack } from "@mui/system";
import {
  Typography,
  Card,
  CardContent,
  Slider,
  Button,
  Checkbox,
  Link,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle
} from "@mui/material";
import { RobotoTypo } from "../../utils/Typographies";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { useTranslation } from "react-i18next";
import customSlider from "../../utils/theme";
import correctImg from "../../assets/svg/correct.png";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import SuccessIcon from "../../assets/payment/Vector.svg";
import {
  studentBox,
  studentContent,
  studentOuterBox,
  studentTitle,
} from "./UniversityView";
import ToastAlert from "../../utils/Alert";
import TermsAndConditions from "../../components/ApplicationForm/University/TermsCondition";
import { useSelector } from "react-redux";
import paynowImage from '../../assets/paynow.avif'
import atmCardImage from '../../assets/atmCards.png'
import CheckIcon from '@mui/icons-material/Check';
import { Close } from "@mui/icons-material";
import UploadedDocumentsView from "./UploadedDocumentsView";

const paymentMethods = [
  {
    id : 1,
    name : 'Card',
    type : 'card',
    image : atmCardImage
  },
  {
    id : 2,
    name : 'Paynow', 
    type : 'paynow',
    image : paynowImage
  }
]

function SchoolView() {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate()
  const language = useSelector((state) => state.language.language)
  const payment_id = localStorage.getItem("payment_id")
  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [applicationFee, setApplicationFee] = useState(0)
  const [consultationFee, setConsultationFee] = useState(0)
  const [serviceFee, setServiceFee] = useState(0)
  const [toastStatus, setToastStatus] = useState({
    color: "",
    status: false,
    message: "",
    icon: "",
  });
  const [loading, setLoading] = useState(false);

  const [discountData, setDiscountData] = useState([])
  const [applicationData, setApplicationData] = useState({});
  console.log("applicationData", applicationData);
  const [payAmount, setPayAmount] = useState(9.99)

  const [discountAmount, setDiscountAmount] = useState(0)
  const [discountPercentage, setDiscountPercentage] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [finalAmount, setFinalAmount] = useState(0)

  const [paymentData, setPaymentData] = useState({})
  const [openQr, setOpenQr] = useState(false)
  const [selectedPayment, setSelectedPayment] = useState({})
  const [timeLeft, setTimeLeft] = useState(10 * 60);
  const [openPaymentModal, SetOpenPaymentModal] = useState(false)
  const [openSuccessModal, setOpenSUccessModal] = useState(false)
  const [paymentDataOmise, setPaymentDataOmise] = useState({})

  const convertPrice = () => {
    return Math.round(Number((payAmount * 100).toFixed(2)));
  }

  const fetchApplicationData = async () => {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/student-application/${id}`)
      .then((response) => {
        console.log(response.data);
        setApplicationData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const fetchDiscounts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/discounts`);
        if (response && response.data) {
          setDiscountData(response.data)
          console.log(response.data)
        } else {
          console.log('No data received');
        }
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    };
    
    fetchDiscounts()
  }, []);

  const handleOmiseResponse = async (tokenID) => {
    console.log("called omise response");
    console.log(tokenID)
    const price = convertPrice()
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/charge`,
        {
          token: tokenID,
          user_id: applicationData?.StudentDetails?.user_id,
          application_id: applicationData?._id,
          amount: price,
          user_email: applicationData?.StudentDetails?.personalDetails?.email,
        }
      );
      console.log(response?.data);
      localStorage.setItem("payment_id", response?.data?.id);
      setLoading(false);
      if (response.data.authorize_uri) {
        window.location.href = response.data.authorize_uri;
      } else {
        console.log("Charge response:", response.data.authorize_uri);
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      setToastStatus({
        color: "red",
        status: true,
        icon: "close",
        message: error.response.data?.error || "Invalid data provided!",
      });
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    if (e) {
      e.preventDefault();
    }
    try {
      console.log("Attempting to open OmiseCard");
      if (typeof window.OmiseCard !== "undefined") {
        const amount = convertPrice();
        if (!amount || amount <= 0) {
          console.error("Invalid amount:", amount);
          return;
        }
        console.log("Opening OmiseCard with amount:", amount);
        window.OmiseCard.open({
          amount: amount,
          currency: "SGD",
          frameLabel: "DR Pacific Holdings",
          submitLabel: "Pay Now",
          // otherPaymentMethods: [
          //   "alipay_hk",
          //   "kakaopay",
          //   "touch_n_go",
          //   "wechat_pay",
          //   "paynow",
          // ],
          onCreateTokenSuccess: handleOmiseResponse,
          onFormClosed: () => {
            console.log("Payment form closed");
            setLoading(false);
            setSelectedPayment({})
            // Reset any relevant state here if needed
          },
        });
      } else {
        console.error("OmiseCard is not available");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  

  const handleOmisePayNowResponse = async () => {
    const price = convertPrice()
    console.log(price)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/charge/paynow`,
        {
          user_id : applicationData?.StudentDetails?.user_id,
          application_id : applicationData?._id,
          amount: price,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('student_token')}`, 
          }
        }
      );
      console.log('response', response)
      console.log("Charge response:", response.data);
      localStorage.setItem("payment_id", response?.data?.id);
      setPaymentData(response.data)
      setOpenQr(true)
     
      // if (response.data.authorize_uri) {
      //   window.location.href = response.data.authorize_uri;
      // } else {
      //   console.log("Charge response:", response.data.authorize_uri);
      // }
    } catch (error) {
      console.error("Error processing payment:", error);
      setToastStatus({
        color: "red",
        status: true,
        icon: "close",
        message: error.response.data?.error || "Invalid data provided!",
      });
    }
  };

  useEffect(() => {
    if(applicationData?.studentDetails?.payment_details === undefined || applicationData?.StudentDetails?.payment_details?.paid === false){
      if (applicationData?.StudentDetails?.user_id && selectedPayment?.type == 'card' ) {
        console.log("userId", applicationData?.StudentDetails?.user_id);
        handleSubmit();
      } else if(applicationData?.StudentDetails?.user_id && selectedPayment?.type == 'paynow'){
        SetOpenPaymentModal(false)
        handleOmisePayNowResponse()
        setTimeLeft(10 * 60)
      }
    }
  }, [applicationData, selectedPayment]);

  const handleCheckboxChange = (event) => {
    setTermsChecked(event.target.checked);
    setTermsError(false); // Clear error when the checkbox is checked
  };
  const downloadInvoice = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/generateInvoicePdf/${id}`,
        {
          headers : {
            Authorization : `Bearer ${localStorage.getItem('student_token')}`
          },
          responseType: "blob", // Ensure the response is treated as a binary Blob
        }
      );

      // Create a URL for the Blob and download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice_${id}.pdf`); // Set the file name
      document.body.appendChild(link);
      link.click();

      // Clean up the link after download
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    }
    // axios
    //   .get(`${process.env.REACT_APP_BASE_URL}/generateInvoicePdf/${id}`)
    //   .then((response) => {
    //     console.log(response.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  useEffect(() => {
    if (id) {
      fetchApplicationData();
    }
  }, [id]);


  const calculateTotalAmount = (selectedSchools) => {
    return selectedSchools.reduce((total, school) => {
      // const mandatoryServicesTotal = school.services
      //   .filter((service) => service.mandatory) // Only mandatory services
      //   .reduce((sum, service) => sum + Number(service.amount_en), 0); // Sum service amounts
      const amount = parseFloat(school?.application_fee_amount)
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  const calculateConsultationAmount = (selectedSchools) => {
    return selectedSchools.reduce((total, school) => {
      // const mandatoryServicesTotal = school.services
      //   .filter((service) => service.mandatory) // Only mandatory services
      //   .reduce((sum, service) => sum + Number(service.amount_en), 0); // Sum service amounts
      const amount = parseFloat(school?.consultation_fee_amount)
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  const calculateServiceAmount = (serviceData) => {
    if(serviceData === undefined || serviceData === null){
      return 0
    }
    return serviceData.reduce((total, service) => {
      return total + parseFloat(service?.amount)
    }, 0)
  }

  useEffect(() => {
    if (applicationData?.StudentDetails?.selected_schools?.length >= 0) {
      const totalAmount = calculateTotalAmount(applicationData?.StudentDetails?.selected_schools).toFixed(2)
      const consultAmount = calculateConsultationAmount(applicationData?.StudentDetails?.selected_schools).toFixed(2)
      const serviceAmount = calculateServiceAmount(applicationData?.StudentDetails?.selected_services)
      console.log(serviceAmount)
      setTotalAmount(parseFloat(totalAmount) + parseFloat(consultAmount) + parseFloat(serviceAmount))
      setApplicationFee(totalAmount)
      setConsultationFee(consultAmount)
      setServiceFee(serviceAmount)
      console.log(totalAmount)
      console.log(serviceAmount)
      console.log(consultAmount)
   
  
      // Find matching discount based on form_count
      const discountItem =  discountData.filter((discount) => discount.discount_details.form_count <= applicationData?.StudentDetails?.selected_schools?.length);
      console.log(discountItem)
      if (discountItem.length > 0) {
        const discountPercentage = discountItem[discountItem?.length - 1]?.discount_details?.discount_percentage;
        // const discountedAmount = (totalAmount - (totalAmount * discountPercentage) / 100).toFixed(2);
        const discountConsultAmount = (consultAmount - (consultAmount * discountPercentage) / 100).toFixed(2);

        console.log("Discount Applied:", discountPercentage, "%");
        console.log("Total After Discount:", discountConsultAmount);
        setDiscountAmount((consultAmount - discountConsultAmount).toFixed(2))
        const final_amount = (parseFloat(totalAmount) + parseFloat(discountConsultAmount) + parseFloat(serviceAmount)).toFixed(2)
        setPayAmount(final_amount)
        setDiscountPercentage(discountPercentage)
        setFinalAmount(final_amount)
      } else {
        console.log("No discount applicable");
        setPayAmount(parseFloat(totalAmount) + parseFloat(consultAmount) + parseFloat(serviceAmount))
        setFinalAmount(parseFloat(totalAmount) + parseFloat(consultAmount) + parseFloat(serviceAmount))
        setDiscountAmount(0)
        setDiscountPercentage(0)
      }
    }
  }, [applicationData?.StudentDetails?.selected_schools, applicationData?.StudentDetails?.selected_services, discountData]);


  

  const paymentIcon = (status) => {
    switch (status) {
      case "successful":
        return (
          <img
            style={{ width: "40px", height: "40px" }}
            alt="payment-indicator"
            src={SuccessIcon}
          />
        );

      case "pending":
        return <PendingActionsIcon sx={{ color: "#FF7900 " }} />;

      default:
        return <SmsFailedIcon sx={{ color: "red" }} />;
    }
  };
  const paymentTitle = (status) => {
    switch (status) {
      case "successful":
        return "Payment was successful ";

      case "pending":
        return "";

      default:
        return "Payment failed.";
    }
  };
  const generatePaymentStatus = (status, applicationData) => {
    console.log("status", status);
    if (status !== undefined) {
      console.log("status1", status);
      return (
        <Stack py={"60px"} alignItems={"center"} gap={"20px"}>
          <>
            {" "}
            <style>
              {`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');
        
        .poppins-text {
            font-family: 'Poppins', sans-serif;
        }
    `}
            </style>
          </>

          <Box width="100%" display={"flex"} justifyContent={"center"}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                backgroundColor:
                  status === "successful"
                    ? "rgba(35, 162, 109, 0.12)"
                    : status === "pending"
                    ? "rgba(255, 121, 0, 0.12)"
                    : "rgba(255, 0, 0, 0.12)",
              }}
            >
              <Box
                sx={{ width: "60px", height: "60px" }}
                display="flex"
                justifyContent={"center"}
                alignItems={"center"}
              >
                {paymentIcon(status)}
              </Box>
            </Box>
          </Box>
          <Typography
            sx={{
              color: "#474747",
              fontFamily: "poppins",
              fontWeight: "400",
              fontSize: "14px",
            }}
          >
            {paymentTitle(status)}
          </Typography>
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <RobotoTypo sx={{ zIndex: 2, fontSize: "1.4rem" }}>S$ {" "}</RobotoTypo>{" "}
            <RobotoTypo
              sx={{
                fontSize: "2.5rem",
                fontWeight: 700,
                zIndex: 3,
                background: "linear-gradient(90deg, #23074d 0%, #cc5333 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {" "}
              {applicationData?.StudentDetails?.payment_details?.amount /
                100}{" "}
            </RobotoTypo>{" "}
          </Box>
          {status === "successful" && (
            <Button variant="contained" onClick={downloadInvoice}>
              Download Invoice
            </Button>
          )}
        </Stack>
      );
    }
  };


  const handleSelectPayment = (data) => {
    setSelectedPayment(data)   
}

const handleOpenPaymentMethods = () => {
  SetOpenPaymentModal(true)
}


useEffect(() => {
  let timer;

  if (openQr && timeLeft > 0) {
    timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
  }

  if (timeLeft === 0) {
    setOpenQr(false);
    SetOpenPaymentModal(true)
    setToastStatus({
      color: "red",
      status: true,
      icon: "close",
      message: "Payment closed, again choose payment method.",
    });
    localStorage.removeItem("payment_id");
  }

  return () => clearInterval(timer); // Cleanup timer on unmount
}, [openQr, timeLeft]);

// Helper function to format time as MM:SS
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

const GetPaymentStatus = async () => {
  if (!payment_id) return;

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/getPaymentDetailsByID`,
      { payment_id },
      {
        headers: {
          Authorization: localStorage.getItem("student_token"),
        },
      }
    );

    const payment = response?.data?.details?.payment;
    console.log("Payment Response:", payment);

    if (response.status === 200 && payment) {
      // setStatus(payment.status);

      if (payment.paid && payment.status === "successful") {
        // navigate("/payment-success"); // Redirect on success
        setToastStatus({
          color: "green",
          status: true,
          message: "Payment Successful!",
          icon: "",
        })
        setOpenSUccessModal(true)
        setPaymentDataOmise(payment)
        setOpenQr(false)
        fetchApplicationData()
        localStorage.removeItem("payment_id")
        setSelectedPayment({})
        setTimeout(() => {
          setToastStatus({
            color: "",
            status: false,
            message: "",
            icon: "",
          })
        },5000)
        
        return;
      }

      if (!payment.paid && payment.status === "pending") {
        // setStatus("pending");
        return; // Continue polling
      }

      if (payment.status === "failed") {

        setToastStatus({
          color: "red",
          status: true,
          message: "Payment failed! Try again later.",
          icon: "",
        })
        setTimeout(() =>{
          setToastStatus({
            color: "",
            status: false,
            message: "",
            icon: "",
          })
        }, 5000)
        
        setOpenQr(false)
        localStorage.removeItem("payment_id")
        setSelectedPayment({})
        setPaymentDataOmise(payment)
        setOpenSUccessModal(true)
        // navigate("/payment-success"); // Redirect on failure
        return;
      }
    }
  } catch (error) {
    console.error("Error fetching payment status:", error);
  }
};

useEffect(() => {
  if (payment_id && selectedPayment?.type === "paynow") {
    const intervalId = setInterval(() => {
      GetPaymentStatus();
    }, 5000);

    return () => clearInterval(intervalId); // Cleanup on unmount
  }
}, [selectedPayment, payment_id]);



  return (
    <>
      <ToastAlert
        message={toastStatus?.message}
        status={toastStatus?.status}
        color={toastStatus?.color}
        icon={toastStatus?.icon}
        closeFunc={() => setToastStatus({ color: "", status: false })}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Card sx={{ m: 0, width: { xs: "100%", sm: "75%" } }}>
          <CardContent
            sx={{
              p: 2,
              m: 0,
              border: "1px solid #e5e5e5",
              overflowY: "auto",
              height: "72.5vh",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("personal_details")}
              </RobotoTypo>
            </Box>

            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails?.name ||
                      "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.passport_name", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.passport_name || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.religious_beliefs", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.religious_belief || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.country_of_birth", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.country_of_birth || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.school_name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                  {applicationData?.StudentDetails?.selected_schools?.length > 0
                    ? applicationData.StudentDetails.selected_schools.map((data, index) => (
                        <span key={index}>
                          {data?.[language]?.school_name}
                          <br />
                        </span>
                      ))
                    : applicationData?.StudentDetails?.personalDetails?.school_name}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.recent_grade_attended", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.recent_grade_attended || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Expected_Enrolment_Date", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.expected_enrolment_date || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Grade_Applying_For", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.grade_applying_for || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.School_Address", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.school_address || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.School_Contact_Phone", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
  {applicationData?.StudentDetails?.personalDetails?.school_contact
    ? `+${applicationData.StudentDetails.personalDetails.school_contact}`
    : "-"}
</Typography>

                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.School_Contact_Email", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.school_email || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Teacher_Name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.teacher_name || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Teacher_Email", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.teacher_email || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Residential_Address", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.personalDetails
                      ?.residential_address || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Address_five_years_one", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {(applicationData?.StudentDetails?.personalDetails
                      ?.Is_lived_in_pastfiveyears === "false") ? "No" : "Yes" || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentBox}></Box>
            </Box>

            <Box
              sx={{
                mt: 3,
                p: 2,
                borderTop: "1px solid #e5e5e5",
                borderBottom: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.Language_Survey", { returnObjects: true })}
              </RobotoTypo>
            </Box>

            <RobotoTypo sx={{ m: 2.5, fontWeight: 600, color: "#003B5C" }}>
              1.{" "}
              {t("ApplicationForm.Primary_Language", { returnObjects: true })}
            </RobotoTypo>
            {applicationData?.StudentDetails?.personalDetails?.primary_languages.map(
              (data, i) => (
                <>
                  <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Language", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.name || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Level", { returnObjects: true })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.level || "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
              )
            )}

            <RobotoTypo sx={{ m: 2.5, fontWeight: 600, color: "#003B5C" }}>
              2.{" "}
              {t("ApplicationForm.languages_level_title", {
                returnObjects: true,
              })}
            </RobotoTypo>
            {applicationData?.StudentDetails?.personalDetails?.language_levels.map(
              (data, i) => (
                <>
                  <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Language", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.name || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Reading", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.reading || "-"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Speaking", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.speaking || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Writing", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.writing || "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
              )
            )}

            <Box sx={studentOuterBox}>
              <Box sx={studentBox}>
                <RobotoTypo sx={{ m: 2.5, fontWeight: 600, color: "#003B5C" }}>
                  3.{" "}
                  {t(
                    "ApplicationForm.How_many_years_have_you_learned_English",
                    {
                      returnObjects: true,
                    }
                  )}
                </RobotoTypo>
                <Typography sx={studentContent} px={2}>
                  {applicationData?.StudentDetails?.personalDetails
                    ?.years_learned_english || "-"}
                </Typography>
              </Box>

              <Box sx={studentBox}>
                {/* <Typography sx={studentTitle}>{t('ApplicationForm.Reading', { returnObjects: true })}</Typography>
                        <Typography sx={studentContent}>{data?.reading || '-'}</Typography> */}
              </Box>
            </Box>

            <RobotoTypo sx={{ m: 2.5, fontWeight: 600, color: "#003B5C" }}>
              4.{" "}
              {t("ApplicationForm.what_kind_of_person_title", {
                returnObjects: true,
              })}
            </RobotoTypo>
            {applicationData?.StudentDetails?.personalDetails?.kind_of_person.map(
              (data, i) => (
                <>
                  <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
                    <Stack
                      columnGap={5}
                      direction={{ xs: "column", md: "row" }}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <RobotoTypo
                        sx={{
                          fontWeight: 500,
                          color: "#003B5C",
                          fontSize: { xs: "14px", sm: "16px" },
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      >
                        {t(`ApplicationForm.${data?.name1}`, {
                          returnObjects: true,
                        })}
                      </RobotoTypo>
                      <Slider
                        disabled
                        value={data?.value}
                        name="value"
                        step={10}
                        sx={{
                          color: "#bdbdbd",
                          "&.Mui-disabled": {
                            color: "#009688",
                            cursor: "not-allowed",
                            "& .MuiSlider-thumb": {
                              backgroundColor: "#009688",
                            },
                            "& .MuiSlider-track": {
                              backgroundColor: "#d1ece9",
                            },
                            "& .MuiSlider-rail": {
                              backgroundColor: "#66c0b7",
                            },
                          },
                        }}
                      />
                      <RobotoTypo
                        sx={{
                          fontWeight: "500",
                          color: "#003B5C",
                          fontSize: { xs: "14px", sm: "16px" },
                          minWidth: "140px",
                          textAlign: "center",
                        }}
                      >
                        {t(`ApplicationForm.${data?.name2}`, {
                          returnObjects: true,
                        })}
                      </RobotoTypo>
                    </Stack>
                  </Box>
                </>
              )
            )}

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.father_info_title", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.name || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Average_monthly_income", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.avg_month_sal || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Current_deposit", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.current_deposit || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Phone", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.phone || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Email", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.email || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Highest_education_level", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.high_edu_level || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Occupation_type", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.occupation_type || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Position", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.position || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.company_name || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Phone", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.company_phone || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Address", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.company_address || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Is_company_UnitedStates", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {(applicationData?.StudentDetails?.familyDetails
                      ?.fatherDetails?.Is_company_US === "false") ? "No" : "Yes" || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* -------------------------------------- */}

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.mother_info_title", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.name || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Average_monthly_income", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.avg_month_sal || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Current_deposit", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.current_deposit || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Phone", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.phone || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Email", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.email || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Highest_education_level", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.high_edu_level || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Occupation_type", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.occupation_type || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Position", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.position || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.company_name || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Phone", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.company_phone || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Company_Address", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.company_address || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Is_company_UnitedStates", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.motherDetails?.Is_company_US || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.Applicant_Siblings_Information", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            {applicationData?.StudentDetails?.familyDetails?.SiblingsInfo.map(
              (data, i) => (
                <>
                  <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.name", { returnObjects: true })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.name || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.passport_name", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.passport_name || "-"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Relationship", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.relationship || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.dob", { returnObjects: true })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.dob || "-"}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={studentOuterBox}>
                      <Box sx={studentBox}>
                        <Typography sx={studentTitle}>
                          {t("ApplicationForm.Nationality", {
                            returnObjects: true,
                          })}
                        </Typography>
                        <Typography sx={studentContent}>
                          {data?.nationality || "-"}
                        </Typography>
                      </Box>

                      <Box sx={studentBox}></Box>
                    </Box>
                  </Box>
                </>
              )
            )}

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.Applicant_Grandmother_Information", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.name", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.grandmotherInfo?.name || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.passport_name", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.grandmotherInfo?.passport_name || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Relationship", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.grandmotherInfo?.relationship || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.dob", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.grandmotherInfo?.dob || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Nationality", { returnObjects: true })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.familyDetails
                      ?.grandmotherInfo?.nationality || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentBox}></Box>
            </Box>

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.Development_health_history_Title", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_1", {
                      returnObjects: true,
                    })}
                  </Typography>

                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.have_physical_disability || "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details?.have_physical_disability_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details
                        ?.have_physical_disability_des || "-"}
                    </Typography>
                  )}
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_2", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.have_serious_hlth_prob || "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details?.have_serious_hlth_prob_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details?.have_serious_hlth_prob_des ||
                        "-"}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_3", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.difficulty_In_physical_skills ||
                      "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details
                    ?.difficulty_In_physical_skills_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details
                        ?.difficulty_In_physical_skills_des || "-"}
                    </Typography>
                  )}
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_4", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.had_trouble_paying_attention ||
                      "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details
                    ?.had_trouble_paying_attention_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details
                        ?.had_trouble_paying_attention_des || "-"}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_5", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.have_allergies || "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details?.have_allergies_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details?.have_allergies_des || "-"}
                    </Typography>
                  )}
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_6", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.Is_taking_any_medication || "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details?.Is_taking_any_medication_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details
                        ?.Is_taking_any_medication_des || "-"}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_7", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.can_use_toilet_independently ||
                      "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details
                    ?.can_use_toilet_independently_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details
                        ?.can_use_toilet_independently_des || "-"}
                    </Typography>
                  )}
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Development_health_history_8", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.health_history_Details?.can_wear_his_clothes || "-"}
                  </Typography>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.health_history_Details?.can_wear_his_clothes_des && (
                    <Typography sx={{ ...studentContent, mt: 1 }}>
                      {applicationData?.StudentDetails?.otherDetails
                        ?.health_history_Details?.can_wear_his_clothes_des ||
                        "-"}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("ApplicationForm.Applicants_American_School_Singapore", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>

           
            <Box sx={{ border: "1px solid #e5e5e5", p: 2, m: 2 }}>
            <RobotoTypo sx={{fontWeight: 600, color: "#003B5C" }}>
              1.{" "}
              {t("ApplicationForm.Applicant_Father", { returnObjects: true })}
            </RobotoTypo>
              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.favorite_hobby", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.american_school_sg?.father_fav_hobby || "-"}
                  </Typography>
                </Box>

                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.Is_interesting_you’d_like_us_to_know", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.american_school_sg?.father_intersting_thing || "-"}
                  </Typography>
                </Box>
              </Box>

              <RobotoTypo sx={{ fontWeight: 600, color: "#003B5C" }}>
                2.{" "}
                {t("ApplicationForm.Applicant_Mother", { returnObjects: true })}
              </RobotoTypo>

              <Box sx={studentOuterBox}>
                <Box sx={studentBox}>
                  <Typography sx={studentTitle}>
                    {t("ApplicationForm.favorite_hobby", {
                      returnObjects: true,
                    })}
                  </Typography>
                  <Typography sx={studentContent}>
                    {applicationData?.StudentDetails?.otherDetails
                      ?.american_school_sg?.mother_fav_hobby || "-"}
                  </Typography>
                </Box>
              </Box>

              <Box sx={studentBox}>
                <Typography sx={studentTitle}>
                  {t("ApplicationForm.Is_interesting_you’d_like_us_to_know", {
                    returnObjects: true,
                  })}
                </Typography>
                <Typography sx={studentContent}>
                  {applicationData?.StudentDetails?.otherDetails
                    ?.american_school_sg?.mother_intersting_thing || "-"}
                </Typography>
              </Box>
            </Box>
            

            <Box
              sx={{
                p: 2,
                borderBottom: "1px solid #e5e5e5",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                alignItems: "center",
                gap: 3,
                justifyContent: "flex-start",
              }}
            >
              <ArticleOutlinedIcon sx={{ color: "#177D84" }} />
              <RobotoTypo
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "16px", sm: "1.2rem" },
                  color: "#177D84",
                }}
              >
                {t("Uploaded Documents", {
                  returnObjects: true,
                })}
              </RobotoTypo>
            </Box>
            <UploadedDocumentsView uploadedDocuments={applicationData?.StudentDetails?.uploadedFiles} baseUrl={process.env.REACT_APP_FILE_URL1} />
          </CardContent>
        </Card>

        <Card
          sx={{
            width: { xs: "100%", sm: " 36%" },
            background: "",
            p: 0,
            m: 0,
            border: "1px solid #e5e5e5",
          }}
        >
          <CardContent
            sx={{
              p: 0,
              m: 0,
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              flexDirection: "column",
              overflowY: "auto",
              height: "72.5vh",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {(applicationData?.StudentDetails?.payment_details?.status !== 'pending' && applicationData?.StudentDetails?.payment_details !== undefined && applicationData?.StudentDetails?.payment_details?.status !== 'failed')  ? (
              <>
                {" "}
                {generatePaymentStatus(
                  applicationData?.StudentDetails?.payment_details?.status,
                  applicationData
                )}{" "}
              </>
            ) : (
              <>
                {" "}
                <>
                  <Stack
                    sx={{
                      padding: "18px 30px",
                      backgroundColor: "#e1e1e1",
                      mb: "30px",
                    }}
                  >
                    <RobotoTypo
                      sx={{
                        fontWeight: "500",
                        color: "#003B5C",
                        fontSize: "20px",
                        textAlign: "left",
                      }}
                    >
                      {t("studentDashboard.application_fees")}
                    </RobotoTypo>
                  </Stack>
                  <Stack gap="30px">
                    <Box>
                    <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{t("school_name")}</Typography>
                              </TableCell>
                              <TableCell>
                                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{t("application_fee")}</Typography>
                              </TableCell>
                              <TableCell>
                                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{t("consultation_fee")}</Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {applicationData?.StudentDetails?.selected_schools?.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <Typography sx={{ fontSize: "16px" }}>{row?.[language]?.school_name}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography sx={{ fontSize: "16px" }}>S$ {row?.application_fee_amount || 0}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography sx={{ fontSize: "16px" }}>S$ {row?.consultation_fee_amount || 0}</Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    
                    {applicationData?.StudentDetails?.selected_services?.length > 0 && (
                      <Box>
                      <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{t("service_name")}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{t("fees")}</Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {applicationData?.StudentDetails?.selected_services?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    <Typography sx={{ fontSize: "16px" }}>{row?.multi_language_names?.[language]?.name}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography sx={{ fontSize: "16px" }}>S$ {row?.amount || 0}</Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                      )}
                    

                    {applicationData?.StudentDetails?.selected_schools?.length > 0 && (
                      <>
              <Box sx={{mr : 1, display : 'flex', justifyContent : 'center', flexDirection : 'row', mt : 0}}>
            <Box>
            <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>{t("total_application_amount")}</Typography>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>S$ {applicationFee}</Typography>
              </Box>

              <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>{t("total_consultation_amount")}</Typography>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>S$ {consultationFee}</Typography>
              </Box>

              <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>{t("total_service_amount")}</Typography>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>S$ {serviceFee}</Typography>
              </Box>

              <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>{t("total_amount")}</Typography>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>S$ {totalAmount}</Typography>
              </Box>

              <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>{t("discount_amount")}</Typography>
              <Typography sx={{fontWeight : 400, fontSize : '1.1rem'}}>S$ {discountAmount}</Typography>
              </Box>

              <Box sx={{display : 'flex', justifyContent : 'space-between', gap : 4}}>
              <Typography sx={{fontWeight : 600, fontSize : '1.1rem'}}>{t("final_amount")}</Typography>
              <Typography sx={{fontWeight : 600, fontSize : '1.1rem'}}>S$ {finalAmount}</Typography>
              </Box>
              </Box>
          </Box>
          <Box sx={{display : 'flex', justifyContent : 'center'}}>
            <Typography sx={{color : '#ff5722', fontSize : '14px'}}>{t("note_discount")}</Typography>
          </Box>
          </>
            )}
                  </Stack>



                  <Stack
                    flexDirection={"row"}
                    px={"20px"}
                    alignItems={"center"}
                    gap="2px"
                    mt="30px"
                  >
                    <Checkbox
                      color="primary"
                      checked={termsChecked}
                      onChange={handleCheckboxChange}
                    />

                    <Typography sx={{ fontSize: "14px" }}>
                      {t("i_agree_to_the")} {" "}
                      <Link
                        href="/terms"
                        target="_blank"
                        sx={{ cursor: "pointer" }}
                        rel="noopener"
                      >
                        {t("terms_and_conditions")}
                      </Link>{" "}
                      {t("and")}{" "}
                      <Link
                        href="/privacyNotice"
                        target="_blank"
                        sx={{ cursor: "pointer" }}
                        rel="noopener"
                      >
                        {t("privacy_notice")}
                      </Link>
                    </Typography>
                  </Stack>
                  {termsError && (
                    <Typography px={"28px"} color="error" variant="body2">
                      {t("please_accept_the_terms_and_conditions_to_proceed")}
                    </Typography>
                  )}
                </>
                {
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: "40px",
                    }}
                  >
                    <Typography variant="h5" gutterBottom>
                    {t('studentDashboard.ready_to_pay')}
                    </Typography>
                    <Typography variant="body1" textAlign="center" gutterBottom>
                    {t("studentDashboard.click_the_button_below")}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={loading}
                      sx={{ mt: 2 }}
                      onClick={(e) => {
                        if (!termsChecked) {
                          setTermsError(true);
                          return;
                        }
                        // handleSubmit(e);
                        handleOpenPaymentMethods()
                      }}
                    >
                      {t("studentDashboard.pay_now")} S${" "}
                      {payAmount}
                    </Button>
                  </Box>
                }
              </>
            )}
          </CardContent>
        </Card>

        <Dialog
       fullWidth
       open={openPaymentModal}
       maxWidth="md"
       onClose={(event, reason) => {
         if (reason === "backdropClick") {
           return; // Prevent closing on backdrop click
         }
        //  onClose(); // Allow other close actions
       }}
       >
        <DialogTitle sx={{ borderBottom: "2px solid #eceef3" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  {t("Select Payment Method")}
                </Typography>
                <Close
                  onClick={() => {
                    SetOpenPaymentModal(false);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Box>
            </DialogTitle>
            <Box sx={{display : 'flex', flexDirection : 'column', padding : '50px',gap : '20px', justifyContent : 'center', alignItems : 'center'}}>
            {paymentMethods.map((data) => (
              <Box onClick={() => handleSelectPayment(data)} sx={{border : '1px solid lightgray', borderRadius : '10px',display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
                  <Box component='img' sx={{":hover" : {cursor : 'pointer'},width : '100px', height : '100px', objectFit : 'cover'}} src={data.image} />
                  <Button  sx={{width : '300px', height : '100px', textTransform : 'none', fontSize : '1.5rem', fontWeight : 700}}>{data.name}</Button>
              </Box>
            ))}
            </Box>
      </Dialog>


      <Dialog
      open={openQr}
      maxWidth="lg"
      onClose={(event, reason) => {
        if (reason === "backdropClick") return; // Prevent closing on backdrop click
      }}
    >
      <DialogTitle sx={{ borderBottom: "2px solid #eceef3" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
            DR Pacific Holdings
          </Typography>

         

          <Close
            onClick={() => {
              setOpenQr(false)
            localStorage.removeItem("payment_id")
            SetOpenPaymentModal(true)
            setSelectedPayment({})
            }}
            style={{ cursor: "pointer" }}
          />
        </Box>
      </DialogTitle>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', pt : '20px'}}>
            <Typography sx={{fontWeight : 700, fontSize : '1.4rem'}}>S$ {payAmount}</Typography>
          </Box>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', }}>
    <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
            Time Left: {formatTime(timeLeft)}
          </Typography>
          </Box>
          <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', }}>
    <Typography style={{ fontSize: "16px", fontWeight: 500 }}>
            Scan QR Code
          </Typography>
          </Box>
      
      <img
        src={paymentData?.source?.scannable_code?.image?.download_uri}
        alt="QR Code"
        style={{ width: "300px", height: "300px", display: "block", margin: "auto" }}
      />

   
    </Dialog>


    <Dialog
       fullWidth
       open={openSuccessModal}
       maxWidth="md"
       onClose={(event, reason) => {
         if (reason === "backdropClick") {
           return; // Prevent closing on backdrop click
         }
        //  onClose(); // Allow other close actions
       }}
       >
         {paymentDataOmise?.status === 'failed' && (
           <>
           <DialogTitle sx={{ borderBottom: "2px solid #eceef3" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  {t("")}
                </Typography>
                <Close
                  onClick={() => {
                    // onClose();
                    setOpenSUccessModal(false);
                    // navigate('/')
                    SetOpenPaymentModal(true)
                    setPaymentDataOmise({})
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Box>
            </DialogTitle>
            <Box sx={{display : 'flex', justifyContent : 'center', mt : 4}}>
            <Box sx={{position : 'relative', border : '10px solid red', borderRadius : '100%', width : '100px', height : '100px', display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
              <Typography sx={{position : 'absolute',fontSize : '5rem', color : 'red', top : '-1rem'}}>x</Typography>
            </Box>
            </Box>
            <Box sx={{display : 'flex', flexDirection : 'column', mb: '20px',padding : '20px',gap : '1px', justifyContent : 'center', alignItems : 'center'}}>
            <Typography sx={{fontSize : '2rem', color : 'black', fontWeight : 700}}>Payment failed!</Typography>
            <Typography sx={{fontSize : '1.2rem', fontWeight : 500}}>{paymentDataOmise?.failure_message}</Typography>
            </Box>
           </>
         )}
        {paymentDataOmise?.status === 'successful' && (
          <>
           <DialogTitle sx={{ borderBottom: "2px solid #eceef3" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                  {t("")}
                </Typography>
                <Close
                  onClick={() => {
                    setOpenSUccessModal(false);
                    setPaymentDataOmise({})
                    // navigate('/')
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Box>
            </DialogTitle>
            <Box sx={{display : 'flex', flexDirection : 'column',justifyContent : 'center', alignItems : 'center', mb : 4}}>
              <Box sx={{border : '10px solid green', width : '100px', height : '100px', display : 'flex', justifyContent : 'center', alignItems : 'center', mt : 4, borderRadius : '100%'}}>
            <CheckIcon sx={{fontSize : '4.5rem', fontWeight : 700, color : 'green'}}/>
            </Box>
              <Typography sx={{fontSize : '2rem', fontWeight : 700, mt : 2}}>Payment Success!</Typography>
            </Box>
            {/* <Box sx={{display : 'flex', flexDirection : 'row', padding : '20px',gap : '20px', justifyContent : 'center', alignItems : 'center'}}>
                <Button variant="outlined" onClick={() => {
                  navigate('/')
                  setOpenSUccessModal(false)
                  }} sx={{textTransform : 'none', width : '40%'}}>Go to Home</Button>
                <Button variant="outlined" onClick={() => {
                  navigate(`/student/applications/university/${applicationData?.application_id}`)
                  setOpenSUccessModal(false)
                  }} sx={{textTransform : 'none', width : '40%'}}>Go to Application view</Button>
            </Box> */}
          </>
        )}
      </Dialog>
      </Box>
    </>
  );
}

export default SchoolView;
